/*
 * @Author: libo 
 * @Date: 2020-11-20 15:16:43 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-01-03 16:07:20
 */

<!-- 抄表异常处理查询 -->
<template>
<a-row :gutter="24">
  <!--
  <a-col :md="collapsed?0: 5" :sm="24">
    <a-card :bordered="false">
      <!-- 按钮操作区域 -->
      <!--
      <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
        <a-alert type="info" :showIcon="true">
          <div slot="message">
            当前选择：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
            <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">取消选择</a>
          </div>
        </a-alert>
        <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" allowClear placeholder="请输入区域名称"/>
        <!-- 树-->
        <!--
        <a-col :md="24" :sm="24">
          <template>
            <a-spin tip="Loading..." :spinning="areaLoading">
              <span style="user-select: none">
                <a-tree
                  class="my-area-select-tree"
                  @select="onSelect"     
                  :selectedKeys="selectedKeys"
                  :treeData="areaTree"
                  :checkStrictly="checkStrictly"
                  :expandedKeys="iExpandedKeys"
                  :autoExpandParent="autoExpandParent"
                  @expand="onExpand">
                  <template slot="title" slot-scope="{title}">
                    <span v-if="title.indexOf(searchAreaValue) > -1">
                      {{title.substr(0, title.indexOf(searchAreaValue))}}
                    <span style="color: #32CD32">{{searchAreaValue}}</span>
                      {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                    </span>
                    <span v-else>{{title}}</span>
                  </template>
                </a-tree>
              </span>
            </a-spin>
          </template>
        </a-col>
      </div>
    </a-card>
  </a-col>
  -->
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px">
      <!--
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
        -->
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :span="18">
              <a-form-item :label="$t('距今')">
                <a-select v-model="condition" style="width: 30%" @change="handleperiodChange">
                  <a-select-option v-for="meterperiod in conditionDataOptions" :key="meterperiod.key" :value="meterperiod.key">
                    {{ meterperiod.title }}
                  </a-select-option>
                </a-select>
                <a-select v-model="punctuation" style="width: 18%;margin-left:5px;">
                  <a-select-option v-for="rate in symbol" :key="rate">
                    {{ $t(rate) }}
                  </a-select-option>
                </a-select>
                <a-input-number v-model="queryParam.days" :min="1" :precision="0" style="width: 30%;margin-left:5px;"></a-input-number>
                <a-select v-model="monad" style="width: 10%;margin-left:5px;">
                  <a-select-option v-for="time in units" :key="time">
                    {{ $t(time) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('部门')">
                <a-select v-model="queryParam.sysOrgCode" :placeholder="$t('请选择部门')" style="margin-left:10px;width: 80%">
                  <a-icon slot="suffixIcon" type="gold" />
                  <a-select-option
                    v-for="d in departList"
                    :key="d.id"
                    :value="d.orgCode">
                    {{ d.departName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls($t('未上报查询'))">{{ $t('导出') }}</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        </div>
        <a-table
          ref="table"
          size="middle"
          tableLayout="fixed"
          :scroll="{ x: 1200 }"
          bordered
          rowKey="userKeyId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">

        </a-table>
      </div>
    </a-card>
  </a-col>
</a-row>
</template>
<script>
import i18n from '@/i18n'
  import '@/assets/less/TableExpand.less'
  import { getAction } from '@/api/manage'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import {isUndefined,isUndefinedAndNull} from'@/utils/validate'
  import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'

  const conditionData = [
    {key: 0,title:i18n.t('未上报天数')},
    /*{key: 1,title:'未用水天数'},
    {key: 2,title:'剩余金额'}*/
  ]
  const cycleData = {
    0:['>='],
    1:['>='],
    2:['<=']
  }
  const timecycleData = {
    0:['天'],
    1:['天'],
    2:['元']
  }
  export default {
    name: 'MeterUpDayAnalysisList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
    },
    data () {
      return {
        title:"",
        condition:0,
        visible: false,
        conditionData,
        cycleData, 
        queryParam:{
        },
        symbol: cycleData['0'],
        punctuation: cycleData['0'],
        units: timecycleData['0'],
        monad: timecycleData['0'],
        description: 'meter_userinfo管理页面',
        collapsed: true,
        url: {
          list: "/jeecg-charge/meter/metereterMaintenance/meterMaintenanceUpRecordsByDate",
          delete: "/jeecg-charge/meter/meterUserinfo/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/metereterMaintenance/exportXlsMeterMaintenanceUpRecordsByDate",
          importExcelUrl: "jeecg-charge/meter/meterUserinfo/importExcel",
        },
        dictOptions:{},
        departList:[],
      }
    },
    created() {
      this.loadDepartList()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：查询条件选项（title 随语言切换）
      conditionDataOptions() {
        return conditionData.map(item => ({ ...item, title: this.$t(item.title) }))
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('最近上报时间'),
            align:"center",
            dataIndex: 'meterSysTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('最近上报总用量(m³)'),
            align:"center",
            dataIndex: 'meterTotalUse',
            width:150,
            ellipsis: true
          },{
            title: this.$t('最近上报阀门状态'),
            align:"center",
            dataIndex: 'meterValveStatus',
            customRender: (t,r,index) => {
              let data = Mn100FkStatusObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:150,
            ellipsis: true
          },{
            title: this.$t('电池状态'),
            align:"center",
            dataIndex: 'meterBatteryStatus',
            customRender: (t,r,index) => {
              let data = {"0": "正常","1":"欠压"}
              if(isUndefined(typeof data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('电池电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage',
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('上报方式'),
            align:"center",
            dataIndex: 'meterUpWay',
            customRender: (t,r,index) => {
              let data = {"0": "定时上传","1":"上电上传","2":"手动上传","3":"故障上传"}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          }
        ]
      }
    },
    methods: {
      loadData(arg) {
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        if(isUndefinedAndNull(this.queryParam.days)||this.queryParam.days === '') {
          this.queryParam.days = 3;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success && res.result!==null) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      handleperiodChange(value) {
        this.symbol = cycleData[value];
        this.punctuation = cycleData[value][0];
        this.units = timecycleData[value];
        this.monad = timecycleData[value][0];
        console.log(`selected ${value}`);
      },
      loadDepartList(){
        let url = "/sys/user/getCurrentUserDeparts"
        getAction(url).then(res=>{
          if(res.success){
            let departs = res.result.list
            this.departList  = departs
          }
        })
      }
    }
  }
</script>
<style scoped>
  .background{
    background-color:rgb(238,238,238)
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>